// AI allowance per vessel (sql/ai-budget.sql): this month's ai_usage cost against clients.ai_monthly_limit_usd (null = no
// limit) - the bars on Admin > AI Activity. tone: red = used up (AI stopped), amber = 80 % or more, green, none = no limit.
export const ALERT_AT = 0.8
export function allowanceRows(usage, vessels, limits, only) {
  const used = {}
  usage.forEach(r => { if (r.client_id) used[r.client_id] = (used[r.client_id] || 0) + (Number(r.cost_usd) || 0) })
  const ids = only ? [only] : Object.keys(vessels).filter(id => limits[id] != null || used[id])
  return ids.map(id => {
    const limit = limits[id] == null ? null : Number(limits[id]), u = used[id] || 0
    const pct = limit == null ? null : limit > 0 ? u / limit : 1
    return { id, name: vessels[id] || 'Unknown vessel', used: u, limit, pct, tone: pct == null ? 'none' : pct >= 1 ? 'red' : pct >= ALERT_AT ? 'amber' : 'green' }
  }).sort((a, b) => (b.pct ?? -1) - (a.pct ?? -1) || b.used - a.used)
}
